<div class="trends-section" fxFlexFill fxLayout="column">

  <div *ngFor="let trend of trends" class="trend-block" fxFlex="25" fxLayout="column">
    <div class="trend-detail-title" fxFlex="35">{{trend.title}}</div>
    <div class="trend-detail-name" fxFlex="35">{{trend.name}}</div>
    <div class="trend-detail-details" fxFlex="30">{{trend.details}}</div>
  </div>
</div>
